import React, { useCallback } from 'react';
import { withDropdownMenu } from 'ui';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';
import { AdministrationMessagesTranslation } from '../../constants';
import { UpdateHandler } from '../types';
import { AdministrationListMessage } from '../types-store';

interface MessagesListItemPublishProps extends DropdownMenuContext {
  message: AdministrationListMessage;
  updateMessage: UpdateHandler;
  disabled: boolean;
  translation: AdministrationMessagesTranslation;
}

const MessagesListItemPublishComponent: React.FC<MessagesListItemPublishProps> = (
  { message, updateMessage, disabled, translation = {}, handleDropdownHide }
) => {

  const updateActive = useCallback(
    () => {
      const active = !message.active;
      updateMessage(message.id,
        { active },
        active ? translation.message_published : translation.message_deactivated);
      !!handleDropdownHide && handleDropdownHide();
    },
    [message.id, message.active, translation]
  );

  return <button type="button" className="dropdown-item" disabled={disabled} onClick={updateActive}>
    {message.active ? translation.deactivate_message : translation.publish_message}
  </button>;
};

export const MessagesListItemPublish = withDropdownMenu(MessagesListItemPublishComponent) as
  React.ComponentType<MessagesListItemPublishProps>;
